import * as React from "react";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Input from "components/bootstrap/Input";
import { Properties } from "views/logic/fieldtypes/FieldType";
import { FieldSource } from "enterprise/parameters/components/option/OptionSource";
import FieldSelect from "views/components/aggregationwizard/FieldSelect";
const isFieldQualified = ({ name, type: { properties } }) => name === "source" || properties.includes(Properties.Enumerable) || properties.includes(Properties.Numeric);
const FieldSourceForm = ({
  idx,
  source: { field, limit },
  onChange,
  onValidate,
  validationState
}) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_common");
  useEffect(() => {
    const fieldValidationState = field !== void 0 && field !== "" ? ["success"] : ["error", t("parameters.field_source.select_field")];
    const limitValidationState = limit !== void 0 && limit > 0 ? ["success"] : ["error", t("parameters.field_source.limit_positive")];
    onValidate(idx, {
      "source.field": fieldValidationState,
      "source.limit": limitValidationState
    });
  }, [field, idx, limit, onValidate, t]);
  useEffect(
    () => () => {
      onValidate(idx, { "source.field": ["success"], "source.limit": ["success"] });
    },
    [idx, onValidate]
  );
  const _onChangeField = useCallback(
    (newField) => onChange(FieldSource.create(newField, limit)),
    [limit, onChange]
  );
  const _onChangeLimit = useCallback(
    (event) => onChange(FieldSource.create(field, Number.parseInt(event.target.value, 10))),
    [field, onChange]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `field-${idx}`,
      name: "field",
      label: t("parameters.field_source.field"),
      bsStyle: (_a = validationState == null ? void 0 : validationState["source.field"]) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState["source.field"]) == null ? void 0 : _b[1]
    },
    /* @__PURE__ */ React.createElement(
      FieldSelect,
      {
        placeholder: t("parameters.field_source.select_or_insert"),
        isFieldQualified,
        ariaLabel: t("parameters.field_source.select_or_insert"),
        name: "parameter-value-input",
        id: "parameter-value-input",
        onChange: _onChangeField,
        allowCreate: true,
        value: field
      }
    )
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `limit-${idx}`,
      name: "limit",
      label: t("parameters.field_source.limit"),
      type: "number",
      value: limit,
      onChange: _onChangeLimit,
      bsStyle: (_c = validationState == null ? void 0 : validationState["source.limit"]) == null ? void 0 : _c[0],
      help: (_d = validationState == null ? void 0 : validationState["source.limit"]) == null ? void 0 : _d[1]
    }
  ));
};
export default FieldSourceForm;
